import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const TermsOfService = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Terms of Service - Truc Doan Real Estate';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Terms of Service for Truc Doan Real Estate services. Review our user obligations, communications policy, and legal terms.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Terms of Service for Truc Doan Real Estate services. Review our user obligations, communications policy, and legal terms.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <div className="privacy-policy-page">
      <button onClick={() => navigate('/')} className="back-home-btn">
        ← Back to Home
      </button>
      <div className="privacy-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section>
          <h2>Important Notice</h2>
          <p>These Terms of Service ("Terms") govern your use of Truc Doan's real estate services and website. By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.</p>
        </section>

        <section>
          <h2>User Obligations</h2>
          <p>You agree to provide accurate and complete information when requested, use our services only for lawful purposes, respect the privacy and rights of other users, not engage in any activity that could harm or disrupt our services, and comply with all applicable local, state, and federal laws.</p>
        </section>

        <section>
          <h2>Communications</h2>
          <p>By using our services, you consent to receive communications from us via email, phone, or text message. These communications may include service updates, property notifications, and marketing materials. You may opt out of marketing communications at any time by contacting us directly.</p>
        </section>

        <section>
          <h2>Accounts</h2>
          <p>When you create an account with us, you are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to suspend or terminate accounts that violate these Terms.</p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>All content on our website, including text, images, logos, and property listings, is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without express written permission.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, Truc Doan and his affiliates shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for our services.</p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>Our services are provided "as is" without warranties of any kind. We do not guarantee the accuracy, completeness, or timeliness of property information. Real estate transactions involve significant financial decisions, and you should conduct your own due diligence and consult with appropriate professionals.</p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law principles. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of California.</p>
        </section>

        <section>
          <h2>Updates</h2>
          <p>We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services after any changes constitutes acceptance of the new Terms.</p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about these Terms of Service, please contact us at <a href="mailto:doanestate@gmail.com">doanestate@gmail.com</a> or <a href="tel:+18188180989">(818) 818-0989</a>.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;